import "./AppointmentModal.scss";

import { useState, useEffect, useCallback } from "react";
import { FaCalendarAlt, FaTimes, FaUser, FaVideo, FaCheck } from "react-icons/fa";

const timeSlots = [
  "10:00 AM","10:30 AM","11:00 AM","11:30 AM","12:00 PM","12:30 PM",
  "01:00 PM","01:30 PM","02:00 PM","02:30 PM","03:00 PM","03:30 PM",
  "04:00 PM","04:30 PM","05:00 PM","05:30 PM","06:00 PM","06:30 PM","07:00 PM"
];

/* ✅ Updated API URL to switch between localhost (dev) and live backend (prod) */
const API_BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:5000/api"
    : "https://ilabackend.digimarqtechnology.com/api";

const AppointmentModal = ({ appointmentOpen, setAppointmentOpen }) => {

  const [fullName,setFullName] = useState("");
  const [mobile,setMobile] = useState("");
  const [appointmentDate,setAppointmentDate] = useState("");
  const [location,setLocation] = useState("");
  const [selectedTime,setSelectedTime] = useState("");
  const [appointmentMode,setAppointmentMode] = useState("");

  const [bookedSlots,setBookedSlots] = useState([]);
  const [loading,setLoading] = useState(false);
  const [submitting,setSubmitting] = useState(false);
  const [message,setMessage] = useState({type:"",text:""});

  const getMinDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate()+1);
    return tomorrow.toISOString().split("T")[0];
  };

  const isSunday = (dateString)=>{
    const date = new Date(dateString);
    return date.getDay()===0;
  };

  const handleDateChange=(e)=>{
    const selectedDate=e.target.value;

    if(selectedDate && isSunday(selectedDate)){
      setMessage({
        type:"error",
        text:"Sundays are not available for appointments"
      });
      setAppointmentDate("");
      return;
    }

    setAppointmentDate(selectedDate);
    setSelectedTime("");
    setMessage({type:"",text:""});
  };

  const fetchBookedSlots = useCallback(async ()=>{
    if(!appointmentDate || !location) return;

    setLoading(true);
    try{
      const response = await fetch(
        `${API_BASE_URL}/slots?date=${appointmentDate}&location=${location}`
      );
      const text = await response.text();
      const data = text ? JSON.parse(text) : [];
      setBookedSlots(data);
    }catch(error){
      console.error(error);
      setBookedSlots([]);
    }
    finally{
      setLoading(false);
    }
  },[appointmentDate,location]);

  useEffect(()=>{
    fetchBookedSlots();
  },[fetchBookedSlots]);

  const handleSubmit = async(e)=>{
    e.preventDefault();

    if(!fullName || fullName.length < 3){
      setMessage({type:"error",text:"Enter valid name"});
      return;
    }

    if(!/^[6-9]\d{9}$/.test(mobile)){
      setMessage({type:"error",text:"Enter valid mobile"});
      return;
    }

    if(!appointmentDate){
      setMessage({type:"error",text:"Select date"});
      return;
    }

    if(!location){
      setMessage({type:"error",text:"Select location"});
      return;
    }

    if(!selectedTime){
      setMessage({type:"error",text:"Select slot"});
      return;
    }

    if(!appointmentMode){
      setMessage({type:"error",text:"Select appointment mode"});
      return;
    }

    setSubmitting(true);

    try{
      const response = await fetch(`${API_BASE_URL}/book`,{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({
          fullName,
          mobile,
          date:appointmentDate,
          time:selectedTime,
          location,
          mode:appointmentMode
        })
      });

      const text = await response.text();
      const data = text ? JSON.parse(text) : {};

      if(response.ok){
        setMessage({
          type:"success",
          text:data.msg || "Appointment booked successfully"
        });

        // WhatsApp notification
        const whatsappMessage = `New Appointment Booking

Name: ${fullName}
Mobile: ${mobile}
Date: ${appointmentDate}
Time: ${selectedTime}
Location: ${location}
Mode: ${appointmentMode}
`;
        const whatsappNumber = "919205020856";
        window.open(`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`,"_blank");

        // Reset form
        setFullName(""); setMobile(""); setAppointmentDate("");
        setLocation(""); setSelectedTime(""); setAppointmentMode("");

        setTimeout(()=>{ setAppointmentOpen(false); },2000);

      }else{
        setMessage({type:"error",text:data.msg || "Booking failed"});
      }

    }catch(error){
      console.error(error);
      setMessage({type:"error",text:"Server not running"});
    }
    finally{ setSubmitting(false); }
  };

  if(!appointmentOpen) return null;

  return (
    <div className="modal-overlay" onClick={()=>setAppointmentOpen(false)}>
      <div className="modal-content" onClick={(e)=>e.stopPropagation()}>
        <div className="modal-header">
          <h3 style={{color:"#833159"}}><FaCalendarAlt/> Book Appointment</h3>
          <button onClick={()=>setAppointmentOpen(false)}><FaTimes/></button>
        </div>

        <form className="appointment-form" onSubmit={handleSubmit}>
          {message.text && <div className={`form-message ${message.type}`}>{message.text}</div>}

          <input type="text" placeholder="Full Name" value={fullName} onChange={(e)=>setFullName(e.target.value)} />
          <input type="tel" placeholder="Mobile Number" value={mobile} onChange={(e)=>setMobile(e.target.value.replace(/\D/g,"").slice(0,10))} />

          <select value={location} onChange={(e)=>{setLocation(e.target.value); setSelectedTime("");}}>
            <option value="">Select Location</option>
            <option value="Pristyn Care Ferticity Super Speciality & IVF Hospital, Delhi">Pristyn Care Ferticity Super Speciality & IVF Hospital, Delhi</option>
            <option value="Dr. Ila Gupta IVF Centre">Dr. Ila Gupta IVF Centre</option>
          </select>

          <input type="date" min={getMinDate()} value={appointmentDate} onChange={handleDateChange} />

          {loading && <p className="loading">Loading available slots...</p>}

          <div className="time-slots">
            {timeSlots.map((slot)=>{
              const isBooked = bookedSlots.includes(slot);
              return (
                <button
                  type="button"
                  key={slot}
                  disabled={isBooked}
                  className={selectedTime===slot?"active":""}
                  onClick={()=>setSelectedTime(slot)}
                >
                  {slot}
                </button>
              );
            })}
          </div>

          <div className="appointment-mode">
            <button type="button" className={appointmentMode==="physical"?"active":""} onClick={()=>setAppointmentMode("physical")}><FaUser/> Physical</button>
            <button type="button" className={appointmentMode==="video"?"active":""} onClick={()=>setAppointmentMode("video")}><FaVideo/> Video</button>
          </div>

          <button type="submit" disabled={submitting}>
            {submitting ? "Booking..." : <><FaCheck/> Confirm Appointment</>}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AppointmentModal;